import userGuideCategoriesImage from "../../../assets/images/user-guide/user-guide-categories.png";
import userGuideDashboardImage from "../../../assets/images/user-guide/user-guide-dashboard.png";
import userGuideEmployeesImage from "../../../assets/images/user-guide/user-guide-employees.png";
import userGuideHeroImage from "../../../assets/images/user-guide/user-guide-hero.png";
import userGuideLoginImage from "../../../assets/images/user-guide/user-guide-login.png";
import userGuideMembershipImage from "../../../assets/images/user-guide/user-guide-membership.png";
import userGuideOrdersImage from "../../../assets/images/user-guide/user-guide-orders.png";
import userGuideProductsImage from "../../../assets/images/user-guide/user-guide-products.png";
import userGuideRegistrationImage from "../../../assets/images/user-guide/user-guide-registration.png";
import userGuideStoresImage from "../../../assets/images/user-guide/user-guide-stores.png";

import { UserGuideImageLayout } from "../enums";
import type { UserGuideImageConfig } from "../types";

export const USER_GUIDE_HERO_IMAGE: UserGuideImageConfig = {
  src: userGuideHeroImage,
  altKey: "user-guide-image-hero-alt",
  altFallback: "Person using a laptop with the Kivunova FMS portal on screen"
};

/** Section id → image below the section heading (see `USER_GUIDE_SECTIONS` in sopContent). */
export const USER_GUIDE_SECTION_IMAGES: Record<string, UserGuideImageConfig> = {
  registration: {
    src: userGuideRegistrationImage,
    altKey: "user-guide-image-registration-alt",
    altFallback: "Registration form for creating a company account"
  },
  login: {
    src: userGuideLoginImage,
    altKey: "user-guide-image-login-alt",
    altFallback: "Sign-in screen with email, password, and forgot password link"
  },
  "portal-dashboard": {
    src: userGuideDashboardImage,
    altKey: "user-guide-image-dashboard-alt",
    altFallback: "Portal dashboard with KPI cards and analytics charts"
  },
  stores: {
    src: userGuideStoresImage,
    altKey: "user-guide-image-stores-alt",
    altFallback: "Map view of multiple store locations"
  },
  "products-vs-items": {
    src: userGuideProductsImage,
    altKey: "user-guide-image-products-alt",
    altFallback: "Product catalogue grid showing catalog items and SKUs"
  },
  categories: {
    src: userGuideCategoriesImage,
    altKey: "user-guide-image-categories-alt",
    altFallback: "Category management screen with parent and sub-categories",
    variant: UserGuideImageLayout.COMPACT
  },
  orders: {
    src: userGuideOrdersImage,
    altKey: "user-guide-image-orders-alt",
    altFallback: "Cashier using a point-of-sale system to process an order"
  },
  employees: {
    src: userGuideEmployeesImage,
    altKey: "user-guide-image-employees-alt",
    altFallback: "Employees list with roles and permissions"
  },
  "membership-apps": {
    src: userGuideMembershipImage,
    altKey: "user-guide-image-membership-alt",
    altFallback:
      "Subscription plans and app download options on laptop and phone"
  }
};
